module.exports = "<p>\n  quibbl works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/quibbl/quibbl.component.html
// module id = ../../../../../src/app/quibbl/quibbl.component.html
// module chunks = main